document.querySelectorAll("slider-component .product-grid").forEach(function(ele) {
    let pos = { left: 0, x: 0 };
    let moving = 0;

    const mouseDownHandler = function (e) {
       // e.preventDefault();
       // e.stopPropagation();
        pos = {
            // The current scroll
            left: ele.scrollLeft,
            // Get the current mouse position
            x: e.clientX,
        };
        moving = 1;
    };

    const mouseMoveHandler = function (e) {
        if(moving != 1) {
            return;
        }
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;

        // Scroll the element
        ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function () {
        moving = 0;
    };

    // Attach the `mousedown` event handler
    ele.addEventListener('mousedown', mouseDownHandler);
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
});

document.querySelectorAll(".card-product1 .btn-next").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        var sel_ind = parseInt(obj.parentElement.getAttribute("data-selected_index"));
        var card__media = obj.closest(".card").querySelector(".card__media");
        var card_count = card__media.querySelectorAll(".media").length;
        if(sel_ind >= card_count) {
            return;
        }

        obj.classList.remove("disabled");
        obj.parentElement.querySelector(".btn-prev").classList.remove("disabled");
        var card_width = card__media.querySelector(".media").offsetWidth;
        var scroll_amount = card_width * sel_ind;
        card__media.scroll({
          left: scroll_amount,
          behavior: 'smooth'
        });

        sel_ind ++;
        if(sel_ind >= card_count) {
            obj.classList.add("disabled");
        }
        obj.parentElement.setAttribute("data-selected_index", sel_ind);
    });
});

document.querySelectorAll(".card-product1 .btn-prev").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        var sel_ind = parseInt(obj.parentElement.getAttribute("data-selected_index"));
        var card__media = obj.closest(".card").querySelector(".card__media");
        var card_count = card__media.querySelectorAll(".media").length;
        if(sel_ind <= 1) {
            return;
        }

        obj.classList.remove("disabled");
        obj.parentElement.querySelector(".btn-next").classList.remove("disabled");
        sel_ind --;

        var card_width = card__media.querySelector(".media").offsetWidth;
        var scroll_amount = card_width * (sel_ind - 1);
        card__media.scroll({
          left: scroll_amount,
          behavior: 'smooth'
        });
        if(sel_ind <= 1) {
            obj.classList.add("disabled");
        }
        obj.parentElement.setAttribute("data-selected_index", sel_ind);
    });
});

document.querySelectorAll(".description_popup-trigger .btn-description").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        document.querySelector(".popup-description .description-content").innerHTML = '';
        document.querySelector(".popup-description-wrapper").classList.remove("hide");
        document.querySelector(".popup-description .description-content").innerHTML = e.currentTarget.parentNode.querySelector('[data-product-description]').innerHTML;
        // fetch(obj.getAttribute("data-url"))
        // .then((response) => response.json())
        // .then((pd) => {
        //     document.querySelector(".popup-description .description-content").innerHTML = pd.description;
        // });
    });
});

document.querySelectorAll(".popup-description-wrapper .btn-close").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        obj.closest(".popup-description-wrapper").classList.add("hide");
    });
});

document.querySelectorAll("select[name='options[Flavor]']").forEach(function(obj) {
  obj.addEventListener("change", function(e) {



    document.querySelectorAll(".thumbnail-list__item").forEach(function(obj1) {
      var alt = obj1.getAttribute("data-alt");


      if(obj.value == alt || !alt || alt == '') {
        obj1.classList.remove("hide");
      }
      else {
        obj1.classList.add("hide");
      }
    });

    document.querySelectorAll(".product__media-item").forEach(function(obj2) {
      var alt = obj2.getAttribute("data-alt");


      if(obj.value == alt || !alt || alt == '') {
        obj2.classList.remove("hide");
      }
      else {
        obj2.classList.add("hide");
      }
    });
  });
});

if(document.querySelector("select[name='options[Flavor]']")) {
  var evt = document.createEvent("HTMLEvents");
  evt.initEvent("change", false, true);
  document.querySelector("select[name='options[Flavor]']").dispatchEvent(evt);
}

document.querySelectorAll(".btn-stack").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        e.preventDefault();
        obj.parentElement.querySelector(".modal-stack").classList.remove("hide");
    });
});

document.querySelectorAll(".modal-stack").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(!(e.target.classList.contains("modal-inner") || e.target.closest(".modal-inner"))) {
            obj.classList.add("hide");
        }
    });
});

document.querySelectorAll(".btn-bundle").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    // e.preventDefault();

    // var link = obj.getAttribute("href");
    // var id = obj.closest(".product__info-wrapper").querySelector("input[name=id]").value;
    // link += "&id=" + id;

    // window.location.href = link;
  });
});

document.querySelectorAll(".product-card-bundle #variant-select").forEach(function(obj) {
  obj.addEventListener("change", function(e) {
    var selected_opt = obj.options[obj.selectedIndex];
    var card = obj.closest(".card");
    var price = "$" + (parseFloat(selected_opt.getAttribute("data-price")) / 100).toFixed(2);
    card.querySelector(".price-item").textContent = price;
    card.querySelector(".atc").setAttribute("data-product", selected_opt.getAttribute("data-price"));
  });
});

document.querySelectorAll('.btn-shop').forEach(function(shopButton) {
  if(!window.location.pathname.includes('apparel')) {
    shopButton.addEventListener('click', function(e) {
        e.preventDefault();
        const quickAddButton = shopButton.closest('.card').querySelector('modal-opener button');
        if (quickAddButton) {
            quickAddButton.click();
        }
        const productFormButton = shopButton.closest('.card').querySelector('product-form button');
        if (productFormButton) {
            productFormButton.click();
        }
    });
  }
});